import { useEffect } from 'react';

/** Default document title and meta description for DinDin Web (SPA). */
export const SITE_TITLE = 'DinDin - Online Order';

export const SITE_META_DESCRIPTION =
  'An easy way to order from your favorite restaurants! Grow your business and reach more customers with DinDin. Start today with $0 monthly fees!';

const META_NAME = 'description';

function upsertMetaDescription(content) {
  let el = document.querySelector(`meta[name="${META_NAME}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', META_NAME);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

/** Keeps `<title>` and meta description in sync on client navigations (CRA SPA). */
export function useSiteDocumentHead() {
  useEffect(() => {
    document.title = SITE_TITLE;
    upsertMetaDescription(SITE_META_DESCRIPTION);
  }, []);
}
